import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SxProps,
} from '@mui/material';
import { FieldHookConfig, useField } from 'formik';
import { setFieldOnSessionStorage } from '../../helpers/helpers';

type RadioGroupProps = FieldHookConfig<string> & {
  label?: string;
  labelStyles?: SxProps;
  optionStyles?: SxProps;
  id: string;
  formName?: string;
  objectId?: string;
  required?: boolean;
  options: {
    value: string;
    label: string;
  }[];
};

const FormikRadioGroup = (props: RadioGroupProps) => {
  const [field, _meta, helpers] = useField(props);
  const {
    label,
    id,
    formName,
    objectId = '',
    required = false,
    options,
    labelStyles,
    optionStyles,
  } = props;
  const { setValue } = helpers;
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  useEffect(() => {
    if (field.value) {
      if (formName) {
        setFieldOnSessionStorage(formName, objectId, field.name, field.value);
      }
      setSelectedValue(field.value);
    } else if (!field.value) {
      setSelectedValue(null);
    }
  }, [field.value]);

  const changeField = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (formName) {
      setFieldOnSessionStorage(formName, objectId, field.name, e.currentTarget.value);
    }
    setValue(e.currentTarget.value);
  };

  return (
    <FormControl required={required} sx={{ scrollMargin: '72px' }}>
      {label && (
        <FormLabel id={`${id}-label`} sx={labelStyles}>
          {label}
        </FormLabel>
      )}
      <RadioGroup row id={id} onChange={changeField} value={selectedValue}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            sx={optionStyles}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default FormikRadioGroup;
